import { createFileRoute } from "@tanstack/react-router";
import AdminModerationPage from "@/admin/pages/moderation";

export const Route = createFileRoute("/admin/moderation")({
  component: AdminModerationPage,
});
